import { ThemeConfigType, FigmaModesType } from '@themes/themeTypes';
import { parseFigmaModes } from '@themes/utils';
import variablesJSON from '@auth_module/theme/figma_variables.json';

const colorModes = variablesJSON.collections.filter(
  (collection) => collection.name === 'colors'
)?.[0].modes;

const figmaVariables = parseFigmaModes(colorModes as FigmaModesType[]);

export const authThemeCfg: ThemeConfigType = {
  light: {
    '--input-focus-text-color': '#051129',

    '--stroke-primary': '#414753',
    '--fill-primary': '#414753',
    '--fill-secondary': '#192576',

    '--bg-input': '#fff',
    '--muted': '#414753',
    '--muted2': '#6C727E',
    '--muted3': '#BBC0C8',
    '--box-shadow-whats-new': '4px 4px 32px rgba(22, 24, 34, 0.4)',

    ...figmaVariables.light,
  },
  dark: {
    '--input-focus-text-color': '#7c8eff',

    '--stroke-primary': '#f1f5f9',
    '--fill-primary': '#f1f5f9',
    '--fill-secondary': '#FFF',
    '--muted': '#A2A8C3',
    '--muted3': '#BBC0C8',

    // Auth module has only light mode design
    ...figmaVariables.light,
  },
};
